import { createAction } from '@reduxjs/toolkit';
import { OPEN_OFFER } from '../constants/offer';

export const openOfferAction = createAction<{ link: string }>(OPEN_OFFER);
